import { Record } from "immutable";

const QuestionRecord = Record({
  qNo: "",
  title: "",
  text: ""
});

class Question extends QuestionRecord {}

export default Question;



// WEBPACK FOOTER //
// ./src/models/Question.js